export const GET_IMAGES_SUCCESS = "GET_IMAGES_SUCCESS";

export const getImagesSuccess = images => {
  return {
    type: GET_IMAGES_SUCCESS,
    values: images
  };
};





// WEBPACK FOOTER //
// ./src/actions/images.js